import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-u9",
  "use": "icon-u9-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-u9\">\n  <g transform=\"matrix(1 0 0 1 -18 0 )\">\n    <path d=\"M 25 0  C 28.92 0  32 3.08  32 7  C 32 10.92  28.92 14  25 14  C 21.08 14  18 10.92  18 7  C 18 3.08  21.08 0  25 0  Z \" fill-rule=\"nonzero\" fill=\"#cb7f4c\" stroke=\"none\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol